import { createSlice } from "@reduxjs/toolkit";
export const DeleteModelFlagSlice = createSlice({
  name: "costHistory",
  initialState: {
    deleteVoucherModelFlag: false,
    deleteCouponModelFlag: false,
  },
  reducers: {
    getVoucherDeleteModelFlag: (state, action) => {
      state.deleteVoucherModelFlag = action.payload;
    },
    getCouponDeleteModelFlag: (state, action) => {
      state.deleteCouponModelFlag = action.payload;
    },
  },
});
export const { getVoucherDeleteModelFlag, getCouponDeleteModelFlag } =
  DeleteModelFlagSlice.actions;
export default DeleteModelFlagSlice.reducer;

